<ul role="tablist">
  @for (link of links; track link) {
    @if (link.name==='-') {
      <li aria-hidden="true" class="divider"></li>
    }
    @if (link.name!=='-') {
      <li [ngClass]="{ 'active': activeLink === link.name, 'link': !!link.tag }"  [title]="link.name" role="tab">
        <button style="background: unset" (click)="link.tag ? setActive(link.name):false">
          @if (link.tag) {
            <span role="presentation" aria-hidden="true" class="mr-2 material-icons">{{link.icon}}</span>
          }
          {{ link.name }}
        </button>
      </li>
    }
  }
</ul>
